<template>
  <div>
    <carousel />
    <quote-paulo-freire />
    <facebook-feed />
    <instagram-feed />
    <volunteer-work />
    <youtube-feed />
  </div>
</template>

<script>
import Carousel from '../components/Carousel';
import QuotePauloFreire from '../components/QuotePauloFreire';
import VolunteerWork from '../components/VolunteerWork';
import InstagramFeed from '../components/InstagramFeed';
import YoutubeFeed from '../components/YoutubeFeed';
import FacebookFeed from '../components/FacebookFeed';

export default {
  name: 'Home',

  components: {
    Carousel,
    QuotePauloFreire,
    VolunteerWork,
    FacebookFeed,
    InstagramFeed,
    YoutubeFeed,
  },
};
</script>

<style scoped>
.volunteerButton {
  color: white;
  font-size: 1.25em;
  font-weight: 800;
}
</style>
